export default "__VITE_ASSET__D5LPtJ6W__"